// Gestores (7-oct-2026). «Propietario y liquidación» (components/Gestores/OwnerSettlementPanel.vue
// y su modal OwnerFormModal.vue): la tarjeta del anuncio donde el gestor dice para quién lo lleva,
// quién cobra y cómo se le liquida.
// Plurales en tres formas (1 | 2-4 | 5 y más): main.js lleva la regla del polaco.
export const ownerSettlement = {
  head: {
    title: "Właściciel i rozliczenie",
    sub: "Jeśli zarządzasz tym obiektem w imieniu innego właściciela, określ, kto otrzymuje płatności, jaka jest Twoja prowizja i jak się z nim rozliczasz. Na tej podstawie powstają jego rozliczenia i Twoja analityka zarządcy.",
  },
  loading: "Wczytywanie ustawień…",
  loadError: {
    title: "Nie udało się wczytać ustawień",
    text: "Sprawdź połączenie i spróbuj ponownie.",
    retry: "Spróbuj ponownie",
  },
  master: {
    label: "Zarządzam tym obiektem w imieniu właściciela",
    hintOff: "Obiekt jest Twój: jego rezerwacje liczą się jako Twoje przychody.",
    hintOn: "Rezerwacje rozliczasz z właścicielem na poniższych warunkach.",
    kept: "Dotychczasowe warunki zostają zachowane na wypadek ponownego włączenia.",
    introTitle: "Po włączeniu:",
    intro1: "Wybierasz właściciela i to, kto otrzymuje płatności za rezerwacje.",
    intro2: "Ustalasz swoją prowizję, VAT i to, kto zatrzymuje sprzątanie.",
    intro3: "Od razu widzisz, jak wygląda jego rozliczenie.",
  },
  owner: {
    title: "Właściciel",
    hint: "Osoba lub firma, z którą rozliczasz ten obiekt.",
    placeholder: "Wybierz właściciela",
    new: "Nowy właściciel",
    add: "Dodaj właściciela",
    edit: "Edytuj",
    emptyTitle: "Nie masz jeszcze właścicieli",
    emptyText: "Dodaj właściciela tego obiektu, aby móc się z nim rozliczać.",
    missing: "Bez przypisanego właściciela rozliczenie tego obiektu nie będzie miało odbiorcy.",
    pending: "Zostanie przypisany po zapisaniu",
    taxId: "NIP",
    addTaxId: "Dodaj NIP",
    iban: "IBAN",
    addIban: "Dodaj IBAN",
  },
  ownerForm: {
    titleNew: "Nowy właściciel",
    titleEdit: "Edytuj właściciela",
    sub: "Jego dane pojawiają się w rozliczeniach obiektów, którymi dla niego zarządzasz.",
    close: "Zamknij",
    name: "Imię i nazwisko lub nazwa firmy",
    taxId: "NIP / PESEL",
    taxIdHint: "Jego numer identyfikacji podatkowej, z dowolnego kraju.",
    taxIdDoubt: "Jeśli to hiszpański NIF, znak kontrolny się nie zgadza. Jeśli numer jest z innego kraju, zignoruj tę uwagę.",
    email: "E-mail",
    phone: "Telefon",
    iban: "IBAN",
    ibanPlaceholder: "PL00 0000 0000 0000 0000 0000 0000",
    ibanHint: "Konto, na które przelewasz jego część.",
    ibanOk: "Poprawny IBAN · {country}",
    address: "Adres",
    notes: "Notatki",
    notesPlaceholder: "Ustalenia, dzień płatności…",
    sharedNote: "Jest też właścicielem {n} innego obiektu: zmiany będą widoczne również tam. | Jest też właścicielem {n} innych obiektów: zmiany będą widoczne we wszystkich. | Jest też właścicielem {n} innych obiektów: zmiany będą widoczne we wszystkich.",
    cancel: "Anuluj",
    save: "Zapisz właściciela",
    saving: "Zapisywanie…",
    created: "Właściciel utworzony",
    updated: "Właściciel zaktualizowany",
    deleted: "Właściciel usunięty",
    errName: "Wpisz imię i nazwisko lub nazwę firmy.",
    errEmail: "Sprawdź adres e-mail: wygląda na nieprawidłowy.",
    errIbanFormat: "IBAN zaczyna się od kodu kraju i dwóch cyfr kontrolnych (PL61…).",
    errIbanCheck: "Cyfry kontrolne się nie zgadzają: sprawdź, czy numer został poprawnie skopiowany.",
    errIbanLength: "IBAN ({country}) powinien mieć długość {expected}, a ten ma {actual}.",
    errSave: "Nie udało się zapisać właściciela. Spróbuj ponownie.",
    errDelete: "Nie udało się usunąć właściciela. Spróbuj ponownie.",
    delete: "Usuń właściciela",
    deleteTitle: "Usunąć: {name}?",
    deleteText: "Zniknie z Twojej listy właścicieli. Tej operacji nie można cofnąć.",
    deleteConfirm: "Usuń",
    deleteBlocked: "Nie można usunąć: jest właścicielem {n} obiektu. Najpierw go stamtąd usuń. | Nie można usunąć: jest właścicielem {n} obiektów. Najpierw usuń go z każdego z nich. | Nie można usunąć: jest właścicielem {n} obiektów. Najpierw usuń go z każdego z nich.",
    discardTitle: "Odrzucić zmiany?",
    discardText: "To, co wpisano dla tego właściciela, zostanie utracone.",
    discardConfirm: "Odrzuć",
    discardCancel: "Edytuj dalej",
  },
  units: {
    title: "Właściciel każdej jednostki",
    hint: "Jeśli któraś jednostka należy do innego właściciela, wybierz go tutaj. Pozostałe rozliczasz z właścicielem oferty.",
    inherit: "Właściciel oferty",
    summaryNone: "Wszystkie należą do właściciela oferty",
    summarySome: "{n} jednostka z innym właścicielem | {n} jednostki z innym właścicielem | {n} jednostek z innym właścicielem",
  },
  collection: {
    title: "Kto otrzymuje płatności za rezerwacje?",
    hint: "To zmienia, dokąd trafiają pieniądze, a nie to, co zostaje właścicielowi.",
    ownerLabel: "Płatności otrzymuje właściciel",
    ownerDesc: "Platformy i Twoja strona płacą właścicielowi. Potem on płaci Twoją fakturę za wynagrodzenie (i za sprzątanie, jeśli należy do Ciebie).",
    managerLabel: "Płatności otrzymuje zarządca",
    managerDesc: "Pieniądze z rezerwacji trafiają do Ciebie. Zatrzymujesz swoją część i przelewasz mu jego.",
    flowBooking: "Rezerwacja",
    flowOwner: "Właściciel",
    flowYou: "Ty",
  },
  commission: {
    title: "Twoja prowizja",
    percent: "Stawka prowizji",
    vat: "VAT od Twojej prowizji",
    base: "Liczona od",
    presetTotal: "Łączna kwota rezerwacji",
    presetAccommodation: "Zakwaterowanie bez sprzątania",
    presetNet: "Netto po prowizji OTA",
    presetDescNet: "{concepts}, bez ich części prowizji OTA",
    presetNetClean: "Net of OTA and cleaning",
    presetDescNetClean: "What the owner keeps before your fee: the total minus the OTA, its VAT and cleaning",
    exampleBase: "podstawa w przykładzie",
    custom: "Własne",
    customize: "Dostosuj ręcznie",
    baseLabel: "Od jakiej kwoty",
    gross: "To, co płaci gość",
    net: "To, co zostaje po prowizji OTA",
    netClean: "What's left after the OTA and cleaning",
    concepts: "Które pozycje się liczą",
    warnTaxes: "Podatki i opłaty nie są przychodem: zwykle nie pobiera się od nich prowizji.",
    fixTaxes: "Usuń podatki i opłaty",
    warnCleaning: "Pobierasz prowizję od sprzątania, które i tak zatrzymujesz.",
    fixCleaning: "Usuń sprzątanie",
    warnDeposit: "Kaucja wraca do gościa: zwykle nie pobiera się od niej prowizji.",
    fixDeposit: "Usuń kaucję",
    errPercent: "Podaj wartość procentową od 0 do 100.",
    errConcepts: "Wybierz co najmniej jedną pozycję.",
  },
  concepts: {
    accommodation: "Zakwaterowanie",
    cleaning: "Sprzątanie",
    taxes: "Podatki i opłaty",
    extras: "Dodatki",
    deposit: "Kaucja",
  },
  // Los mismos conceptos dentro de una frase («Base: alojamiento y extras.»)
  conceptsInline: {
    accommodation: "zakwaterowanie",
    cleaning: "sprzątanie",
    taxes: "podatki i opłaty",
    extras: "dodatki",
    deposit: "kaucja",
  },
  cleaning: {
    title: "Sprzątanie",
    hint: "Kto zatrzymuje to, co gość płaci za sprzątanie?",
    owner: "Należy do właściciela",
    ownerDesc: "Zostaje w jego kwocie netto: nic nie jest potrącane.",
    manager: "Należy do Ciebie",
    managerDesc: "Zajmujesz się nim Ty i jest potrącane właścicielowi.",
    charged: "To, co gość płaci za sprzątanie",
    fixed: "Stała kwota za pobyt",
    fixedAmount: "Kwota za pobyt",
    fixedHint: "Jeśli rezerwacja obejmuje kilka pokoi, kwota liczy się raz za każdy pokój.",
    errAmount: "Podaj stałą kwotę za sprzątanie za pobyt.",
  },
  ota: {
    title: "Prowizja każdej OTA",
    moved: "Procent każdej OTA ustawiasz na karcie „{card}”.",
    open: "Otwórz „{card}”",
  },
  example: {
    title: "Przykładowe rozliczenie",
    sub: "Rezerwacja z {channel} na {total} przy Twoich obecnych warunkach.",
    guest: "Co płaci gość",
    platform: "Co zatrzymuje {channel}",
    platformNote: "Jego prowizja: {pct}% od {base} ({concepts}).",
    platformYours: "Liczą się Twoje % z karty „{card}”, nawet jeśli {channel} prześle swoją prowizję.",
    platformReal: "Jeśli {channel} prześle prowizję od rezerwacji, zostanie użyta ona.",
    platformRule: "Jeśli ustawisz % dla {channel} w „{card}”, liczy się Twój; jeśli nie, jego prowizja.",
    otaVat: "VAT od prowizji {channel} ({pct}%)",
    changeIn: "Zmień na karcie „{card}”",
    changeWhere: "Zmienia się na karcie „{card}”.",
    notOwner: "Co nie należy do właściciela",
    taxes: "Podatki i opłaty",
    taxesNote: "Nie są przychodem właściciela.",
    cleaning: "Sprzątanie, które zatrzymujesz",
    cleaningNoteCharged: "To, co gość za nie płaci.",
    cleaningNoteFixed: "Twoja stała kwota za pobyt.",
    fees: "Twoje wynagrodzenie za zarządzanie",
    commission: "Prowizja: {pct}% od {base}",
    commissionBase: "Podstawa: {concepts}.",
    commissionBaseNet: "Podstawa: {concepts}, bez ich części prowizji {channel}.",
    commissionBaseNetClean: "Base: what the owner keeps after {channel}, its VAT and cleaning.",
    vat: "VAT od Twojej prowizji ({pct}%)",
    invoice: "Razem na Twojej fakturze za wynagrodzenie",
    net: "Netto dla właściciela",
    netNote: "To, co mu się należy z tej rezerwacji.",
    netNegative: "Potrącenia przekraczają to, co zostaje z rezerwacji.",
    splitTitle: "Jak dzieli się {total}",
    legendTaxes: "Podatki i opłaty",
    legendCleaning: "Sprzątanie (Twoje)",
    legendFees: "Twoje wynagrodzenie",
    legendOwner: "Właściciel",
    legendDeficit: "Brakująca kwota",
    transferTitle: "Przelewasz {amount}",
    transferTitleTo: "Przelewasz {amount}, odbiorca: {owner}",
    transferInvoice: "I wystawiasz mu fakturę za wynagrodzenie na {amount}.",
    owesTitle: "Właściciel jest Ci winien {amount}",
    owesTitleFrom: "{owner} ma Ci zapłacić {amount}",
    owesInvoice: "Nie ma nic do przelania. Twoja faktura za wynagrodzenie wynosi {amount}.",
    owesHint: "W tym przykładzie potrącenia przekraczają to, co zostaje z rezerwacji.",
    collectTitle: "Właściciel płaci Ci {amount}",
    collectTitleFrom: "{owner} płaci Ci {amount}",
    collectBreakdown: "To Twoja faktura za wynagrodzenie ({fees}).",
    collectBreakdownCleaning: "Twoja faktura za wynagrodzenie ({fees}) plus sprzątanie ({cleaning}).",
    ownerLoses: "Na tych warunkach właściciel traci na tej rezerwacji {amount}.",
    foot: "Kwoty przykładowe. Rzeczywiste rozliczenie korzysta ze szczegółów każdej rezerwacji.",
    footNoOtaVat: "Bez VAT od prowizji OTA.",
  },
  footer: {
    save: "Zapisz zmiany",
    saving: "Zapisywanie…",
    unsaved: "Niezapisane zmiany",
    saved: "Zapisano",
    fixErrors: "Sprawdź zaznaczone pola.",
    errSave: "Nie udało się zapisać. Spróbuj ponownie.",
    peekLabel: "Zostaje dla właściciela",
    peekAria: "Zobacz przykładowe rozliczenie: dla właściciela zostaje {amount}",
  },
};
